export const ru = {
  // Header
  header: {
    export: 'Экспорт Excel',
    exportSelected: 'Экспорт Excel ({{count}})',
    projects: 'Проекты',
    users: 'Пользователи',
    addArtist: 'Добавить художника',
    addUser: 'Добавить пользователя',
    addProject: '+ Проект',
    addProfile: '+ Профиль',
    logout: 'Выйти',
    goToMagicBox: 'LightBox',
    magicboxUrlNotSet: 'URL LightBox не настроен. Пожалуйста, настройте интеграцию в системных настройках.',
    magicboxError: 'Ошибка при переходе в LightBox',
  },

  // Login
  login: {
    title: 'VFX Spellbook',
    subtitle: 'Профессиональная платформа для управления творческими ресурсами',
    username: 'Имя пользователя',
    password: 'Пароль',
    loginButton: 'Войти',
    usernamePlaceholder: 'Имя пользователя',
    passwordPlaceholder: 'Пароль',
    invalidCredentials: 'Неверные учетные данные',
    email: 'Email',
    emailPlaceholder: 'Адрес электронной почты',
    emailValidationError: 'Введите корректный email',
    forgotPassword: 'Забыли пароль?',
    resetPassword: 'Сброс пароля',
    resetEmail: 'Адрес электронной почты',
    resetEmailPlaceholder: 'Введите адрес электронной почты',
    resetCancel: 'Отмена',
    resetSend: 'Отправить письмо для сброса',
    resetSending: 'Отправка...',
    resetSuccess: 'Инструкции по сбросу пароля отправлены на вашу почту',
    resetError: 'Не удалось отправить письмо для сброса',
    resetConnectionError: 'Ошибка соединения. Попробуйте еще раз.',
    recaptchaRequired: 'Пожалуйста, пройдите проверку reCAPTCHA',
    accountLocked: 'Аккаунт заблокирован',
    tooManyAttempts: 'Слишком много неудачных попыток. Попробуйте снова через',
    attemptsRemaining: 'попыток осталось',
    lockedFor: 'Аккаунт заблокирован на',
    seconds: 'секунд',
    registerLink: 'Зарегистрироваться',
  },

  // Reset Password Page
  resetPassword: {
    title: 'Сброс пароля',
    subtitle: 'Введите новый пароль',
    newPassword: 'Новый пароль',
    newPasswordPlaceholder: 'Введите новый пароль',
    confirmPassword: 'Подтвердите пароль',
    confirmPasswordPlaceholder: 'Повторите новый пароль',
    resetButton: 'Сбросить пароль',
    resetting: 'Сброс...',
    backToLogin: 'Вернуться ко входу',
    fillAllFields: 'Пожалуйста, заполните все поля',
    passwordTooShort: 'Пароль должен содержать минимум 8 символов',
    passwordsMismatch: 'Пароли не совпадают',
    invalidToken: 'Неверная или истекшая ссылка для сброса',
    resetFailed: 'Не удалось сбросить пароль',
    connectionError: 'Ошибка соединения. Попробуйте еще раз.',
    successTitle: 'Пароль успешно сброшен!',
    successMessage: 'Ваш пароль был успешно изменен.',
    redirecting: 'Перенаправление на страницу входа...',
  },

  register: {
    hubTitle: 'Регистрация',
    hubSubtitle: 'Выберите тип заявки',
    formTitle: 'Заявка на регистрацию',
    inviteFormTitle: 'Завершение регистрации',
    organization: 'Организация / студия',
    selectSpecialization: 'Выберите специализацию',
    submitApplication: 'Отправить заявку',
    submitRegister: 'Зарегистрироваться',
    successTitle: 'Заявка отправлена',
    successMessage:
      'Заявка на управляющий доступ отправлена Super Admin. После одобрения вы получите пароль по email.',
    artistSuccessTitle: 'Профиль создан',
    artistSuccessMessage: 'Карточка художника создана. Доступ для входа не запрашивался.',
    inviteSuccessTitle: 'Регистрация завершена',
    inviteSuccessMessage: 'Теперь вы можете войти с email и паролем.',
    backToLogin: 'Вернуться ко входу',
    passwordTooShort: 'Пароль должен содержать минимум 8 символов',
    passwordMismatch: 'Пароли не совпадают',
    types: {
      staffGroup: 'Сотрудники',
      vfxArtist: 'VFX Artist',
      vfxArtistDesc: 'Внешний VFX художник — полная заявка с портфолио',
      vfx_artist: 'VFX Artist',
      client: 'Клиент',
      clientDesc: 'Клиентский портал',
      producer: 'Продюсер',
      supervisor: 'Супервайзер',
      coordinator: 'Координатор',
      sales: 'Sales',
      finder: 'Finder',
      admin: 'Админ',
    },
  },

  accessRequest: {
    toastTitle: 'Заявка на доступ',
    toastMessage: '{{name}} ({{email}})\nПретензия на роль: {{role}}',
    approve: 'Одобрить',
    reject: 'Отклонить',
    approvedTitle: 'Доступ одобрен',
    approvedWithEmail: 'Учётка создана. Пароль отправлен заявителю по email.',
    approvedNoEmail: 'Учётка создана, но письмо с паролем не отправлено. Проверьте SMTP.',
    rejectedTitle: 'Доступ отклонён',
    rejectedMessage: 'Заявка на доступ отклонена.',
    actionFailed: 'Не удалось выполнить действие',
  },

  biddingRevision: {
    toastTitle: 'Ревизия сметы на утверждении',
    toastMessage: '{{editor}} правил «{{sheet}}» ({{project}})\nПравок: {{edits}}',
    approve: 'Одобрить',
    reject: 'Отклонить',
    approvedTitle: 'Ревизия утверждена',
    approvedMessage: 'Черновик стал основной сметой.',
    rejectedTitle: 'Ревизия отклонена',
    rejectedMessage: 'Черновик удалён. Оригинал не изменён.',
    actionFailed: 'Не удалось обработать ревизию',
    bannerPending: 'Вы редактируете черновик на утверждении. Оригинал не меняется, пока Super Admin не одобрит.',
    bannerApproved: 'Ревизия утверждена и стала основной сметой. Новые правки не-админов снова создадут черновик.',
    bannerRejected: 'Черновик отклонён. Вы возвращены к оригинальной смете.',
    dismiss: 'Скрыть',
    badgePending: 'На утверждении',
  },

  profileWizard: {
    selectType: 'Кого создаём?',
    profileFields: 'Данные профиля',
    accessStep: 'Доступ к SpellBook',
    accessHint: 'При необходимости задайте пароль или ссылку регистрации.',
  },

  profile: {
    access: {
      title: 'Доступ',
      hasLogin: 'Вход есть',
      noLogin: 'Нет аккаунта',
      approve: 'Одобрить',
      grantPassword: 'Задать пароль',
      createInvite: 'Ссылка регистрации',
      copyLink: 'Копировать',
      revokeLogin: 'Отключить вход',
      pending: 'На проверке',
      active: 'Активен',
      rejected: 'Отклонён',
      requestAccess: 'Запросить у Super Admin',
      requestSent: 'Заявка отправлена Super Admin',
    },
  },

  // Artist Form
  artistForm: {
    createTitle: 'Добавить нового художника',
    editTitle: 'Редактировать профиль художника',
    personalInfo: 'Личная информация',
    name: 'Имя',
    specialization: 'Специализация',
    email: 'Email',
    telegram: 'Telegram',
    portfolioUrl: 'Портфолио URL',
    description: 'Описание',
    avatar: 'Аватар',
    software: 'Программное обеспечение',
    projectsAndAvailability: 'Проекты и доступность',
    assignedProjects: 'Назначенные проекты',
    projects: 'Проекты',
    availability: 'Доступность',
    save: 'Сохранить',
    cancel: 'Отмена',
    deleteAvatar: 'Удалить аватар',
    page: 'Страница',
    next: 'Далее',
    previous: 'Назад',
    clearDates: 'Очистить',
    optional: 'необязательно',
    avatarUploadHint: 'Загрузите изображение или оставьте пустым для автоматической генерации',
    avatarAutoHint: '💡 Без загрузки: аватар создается из Gravatar (по email) или инициалов имени',
    telegramPlaceholder: '@username или username',
    descriptionPlaceholder: 'Краткое описание навыков, сильных сторон и опыта художника...',
    location: 'Локация',
    locationPlaceholder: 'Город, страна (например: Москва, Россия)',
    selectSpecialization: 'Выберите специализацию',
    showActiveOnly: 'Только активные',
    noActiveProjects: 'Нет активных проектов',
    selectedProjects: 'Выбрано',
    validation: {
      nameRequired: 'Имя обязательно',
      specializationRequired: 'Специализация обязательна',
      contactRequired: 'Требуется email или telegram',
      emailInvalid: 'Неверный формат email',
      urlInvalid: 'Неверный формат URL',
      softwareRecommended: 'Рекомендуется указать программное обеспечение',
      projectsRecommended: 'Рекомендуется назначить проекты',
    },
  },

  // Filter Bar
  filters: {
    search: 'Поиск...',
    searchUsers: 'Поиск по имени художника...',
    searchProjects: 'Поиск по названию или описанию...',
    searchBidding: 'Поиск по названию сметы или проекту...',
    specialization: 'Специализация',
    software: 'ПО',
    project: 'Проект',
    allProjects: 'Все проекты',
    client: 'Клиент',
    clientName: 'Название клиента',
    status: 'Статус',
    priority: 'Приоритет',
    projectType: 'Тип проекта',
    producer: 'Продюсер',
    manager: 'Супервайзер',
    sort: 'Сортировать по',
    all: 'Все',
    allSpecializations: 'Все специализации',
    allProfiles: 'Все профили',
    allStatuses: 'Все статусы',
    allPriorities: 'Все приоритеты',
    allTypes: 'Все типы',
    allProducers: 'Все продюсеры',
    allManagers: 'Все супервайзеры',
    availableToday: 'Доступен сегодня',
    profileType: 'Тип профиля',
    allProfileTypes: 'Все типы',
    registrationStatus: 'Статус заявки',
    selectedCount: 'Выбрано: {{count}}',
    clearAll: 'Очистить все',
  },

  // Sort Options
  sort: {
    nameAsc: 'Имя (А-Я)',
    nameDesc: 'Имя (Я-А)',
    specializationAsc: 'Специализация (А-Я)',
    specializationDesc: 'Специализация (Я-А)',
    createdAsc: 'Дата создания ↑',
    createdDesc: 'Дата создания ↓',
  },

  // Specializations
  specializations: {
    'concept_artist': 'Концепт-художник',
    '3d_modeler': '3D-моделлер', 
    'animator': 'Аниматор',
    'fx_artist': 'FX-художник',
    'vfx_artist': 'VFX-художник', // Устаревшее, для старых записей
    'compositor': 'Композер',
    'rigger': 'Риггер',
    'texture_artist': 'Текстурщик',
    'lighting_artist': 'Лайтинг-художник',
    'matte_painter': 'Мат-пейнтер',
    'matchmove_artist': 'Мачмув-художник',
    'layout_artist': 'Лейаут-художник',
    'rotopaint_artist': 'Ротопейнт-художник',
    'environment_artist': 'Художник окружения',
    'generalist': 'Дженералист',
    'producer': 'Продюсер',
    'coordinator': 'Координатор',
    'supervisor___teamlead': 'Супервайзер / Тимлид',
    'on_set_supervisor': 'Супервайзер на площадке',
    'editor': 'Монтажер',
    'color_grade': 'Колорист',
    'ai___r_d_специалист': 'AI / R&D специалист',
  },

  // User Roles
  roles: {
    'Super Admin': 'Супер Админ',
    'Admin': 'Админ',
    'Producer': 'Продюсер',
    'Project Manager': 'Проект Менеджер',
    'Coordinator': 'Координатор',
    // 'Client': 'Клиент',  // Закомментировано - используем Demo как Client
    'Demo': 'Клиент (SpellBook пользователь)',  // Demo отображается как "Клиент (SpellBook пользователь)"
  },

  // Project Management
  projects: {
    title: 'Управление проектами',
    addProject: 'Добавить проект',
    name: 'Название проекта',
    description: 'Описание',
    startDate: 'Дата начала',
    endDate: 'Дата окончания',
    status: 'Статус',
    projectType: 'Тип проекта',
    notSelected: 'Не выбрано',
    save: 'Сохранить',
    assignedArtists: 'Назначенные художники',
    noAssignedArtists: 'Нет назначенных художников',
    searchArtists: 'Поиск художников...',
    noAvailableArtists: 'Нет доступных художников',
    saveProjectFirst: 'Сначала сохраните проект',
    confirmRemoveArtist: 'Удалить художника из проекта?',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    confirmDelete: 'Удалить проект',
    confirmDeleteText: 'Вы уверены, что хотите удалить проект "{{name}}"?',
    dateError: 'Дата начала не может быть позже даты окончания.',
    deleteMessage: 'Это действие нельзя отменить. Все назначения этого проекта художникам будут также удалены.',
    existingProjects: 'Существующие проекты',
    noProjects: 'Проектов пока нет.',
    createProject: 'Создать проект',
    editProject: 'Редактировать проект',
    wizardStep1: 'Проект',
    wizardStep2: 'Художники',
    wizardSkip: 'Пропустить',
    wizardDone: 'Готово',
    createAndContinue: 'Создать и далее',
    statuses: {
      planning: 'Планирование',
      active: 'Активный',
      completed: 'Завершен',
      onHold: 'Приостановлен',
    },
  },

  // User Management
  userManagement: {
    title: 'Пользователи системы',
    createMode: 'Создание',
    editMode: 'Редактирование',
    createUser: 'Создать пользователя',
    username: 'Имя пользователя',
    usernamePlaceholder: 'Введите имя пользователя',
    email: 'Email',
    role: 'Роль',
    password: 'Пароль',
    generatePassword: 'Сгенерировать пароль',
    copyPassword: 'Копировать пароль',
    save: 'Сохранить',
    cancel: 'Отмена',
    close: 'Закрыть',
    delete: 'Удалить',
    changePassword: 'Изменить пароль',
    changePasswordTitle: 'Изменить пароль пользователя',
    newPassword: 'Новый пароль',
    updatePassword: 'Обновить пароль',
    changeEmail: 'Изменить email',
    changeEmailTitle: 'Изменить email пользователя',
    changingEmailFor: 'Изменение email для',
    currentEmail: 'Текущий email',
    newEmail: 'Новый email',
    newEmailPlaceholder: 'Введите новый email адрес',
    updateEmail: 'Обновить email',
    editEmailMode: 'Редактирование email',
    userList: 'Список пользователей',
    hint: 'Подсказка',
    hintUsername: 'Имя пользователя может быть любым (не обязательно email)',
    hintPassword: 'Используйте кнопку 🔄 для генерации случайного пароля',
    hintEmail: 'Email обязателен для входа в систему',
    hintAdminOnly: 'Только Super Admin может управлять пользователями',
    hintChangePassword: '🔑 Используйте кнопку ключа для изменения пароля любого пользователя',
    hintChangeEmail: '📧 Используйте кнопку email для изменения email любого пользователя',
    loading: 'Загрузка пользователей...',
    noUsers: 'Пользователи не найдены',
    changingPasswordFor: 'Изменение пароля для',
    roles: {
      superAdmin: 'Супер Админ',
      admin: 'Админ',
      producer: 'Продюсер',
      projectManager: 'Проект Менеджер',
      coordinator: 'Координатор',
      sales: 'Сейлс',
      // client: 'Клиент',  // Закомментировано
      demo: 'Клиент (SpellBook пользователь)',  // Demo = Клиент (SpellBook пользователь)
    },
    roleDescriptions: {
      superAdmin: 'Полный доступ к системе, может удалять любых пользователей',
      admin: 'Полный доступ кроме удаления Супер Админа',
      producer: 'Может управлять проектами и художниками',
      sales: 'Ограниченный доступ - видит только проекты где назначен продюсером',
      projectManager: 'Может управлять проектами',
      coordinator: 'Ограниченный доступ к художникам и проектам',
      // client: 'Доступ только к назначенным проектам',  // Закомментировано
      demo: 'Доступ только к назначенным проектам (SpellBook пользователь)',  // Demo = Клиент (SpellBook пользователь)
    },
  },

  // Artist Card
  artistCard: {
    email: 'Email',
    telegram: 'Telegram',
    portfolio: 'Портфолио',
    projects: 'Проекты',
    activeProjects: 'Активные проекты',
    software: 'ПО',
    availability: 'Доступность',
    availableNow: 'Доступен сейчас',
    freeFrom: 'Свободен с',
    freeTo: 'до',
    needsUpdate: 'Необходимо уточнять',
    noAvailability: 'Доступность не указана',
    noProjects: 'Не назначено',
    noActiveProjects: 'Нет активных проектов',
    noContact: 'Не указан',
    noPortfolio: 'Не указано',
    edit: 'Редактировать',
    delete: 'Удалить',
    doubleClickToEdit: 'Двойной клик для редактирования',
  },

  // Confirmations
  confirmations: {
    deleteArtist: 'Удалить художника',
    deleteArtistText: 'Вы уверены, что хотите удалить художника "{{name}}"?',
    deleteProject: 'Удалить проект',
    deleteUser: 'Удалить пользователя',
    yes: 'Да',
    no: 'Нет',
    cancel: 'Отмена',
  },

  // Notifications
  notifications: {
    artistCreated: 'Художник успешно создан',
    artistUpdated: 'Профиль художника обновлен',
    artistDeleted: 'Художник удален',
    projectCreated: 'Проект создан',
    projectUpdated: 'Проект обновлен',
    projectDeleted: 'Проект удален',
    userCreated: 'Пользователь создан',
    userUpdated: 'Пользователь обновлен',
    userDeleted: 'Пользователь удален',
    passwordUpdated: 'Пароль обновлен',
    exportStarted: 'Экспорт начат',
    error: 'Произошла ошибка',
  },

  // View Modes
  viewModes: {
    grid: 'Плитка',
    list: 'Список',
  },

  // Sort Toggle
  sortToggle: {
    sortAZ: 'Сортировка А-Я',
    sortZA: 'Сортировка Я-А',
  },

  // Calendar
  calendar: {
    months: [
      'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
      'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
    ],
    weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
    selectedDates: 'Выбранные даты',
    clear: 'Очистить',
  },

  // Language
  language: {
    ru: 'Русский',
    en: 'English',
  },

  // System Menu
  system: {
    title: 'Системное меню',
    users: {
      title: 'Пользователи',
      description: 'Создание и редактирование пользователей системы',
      create: 'Создать',
      manage: 'Управлять',
      createNew: 'Создать нового пользователя',
      existingUsers: 'Существующие пользователи',
      editUser: 'Редактировать пользователя',
      noUsers: 'Пользователи не найдены'
    },
    admin: {
      projectAccess: {
        title: 'Доступ администратора',
        seeAllProjects: 'Видеть все проекты',
        seeAllProjectsHint: 'Если выключено — только назначенные проекты (по умолчанию)',
      },
    },
    backup: {
      title: 'Резервное копирование',
      description: 'Полный слепок системы и восстановление (только Super Admin)',
      stats: 'Статистика базы данных',
      management: 'Управление резервными копиями',
      instructions: 'Полный ZIP включает дамп БД, настройки и медиа приложения по ссылкам из базы. Осиротевшие файлы не включаются.',
      formats: 'Форматы: ZIP (полный слепок), JSON (только данные)',
      users: 'Пользователи',
      artists: 'Художники',
      projects: 'Проекты',
      assignments: 'Назначения',
      accessDeniedDescription: 'Полный бэкап и скачивание доступны только Super Admin',
      downloadZip: 'Скачать полный бэкап (ZIP)',
      zipLoading: 'Собираем ZIP…',
      zipHint: 'Полный ZIP на больших медиатеках может занять несколько минут.',
      zipSuccess: 'Полный бэкап скачан',
      zipFailed: 'Не удалось выгрузить полный ZIP',
      savedOnServer: 'Также сохранено на сервере',
      connectionError: 'Ошибка соединения. Попробуйте ещё раз.',
      exportJson: 'Экспорт JSON (только данные)',
      importJson: 'Импорт JSON',
      trashTitle: 'Корзина медиа (Trash Bin)',
      trashHint: 'Двухфазная очистка orphaned-файлов в uploads (нет ссылки в БД).',
      trashPhaseHint: 'Фаза 1: перенос в Trash и проверка сайта. Фаза 2: безвозвратная очистка. До Empty можно Restore.',
      trashOrphans: 'Orphans на диске',
      trashInBin: 'В Trash Bin',
      trashViewOrphans: 'Orphans',
      trashViewBin: 'Trash Bin',
      trashRefresh: 'Обновить',
      trashMove: 'Перенести orphans в Trash',
      trashRestoreSelected: 'Восстановить выбранные',
      trashRestoreAll: 'Восстановить всё',
      trashEmpty: 'Очистить Trash',
      trashLoading: 'Сканирование…',
      trashNoOrphans: 'Orphaned-медиа не найдено',
      trashEmptyBin: 'Trash Bin пуст',
      trashColPath: 'Путь',
      trashColSize: 'Размер',
      trashSelected: 'Выбрано: {count} · {size}',
      trashMoveSuccess: 'Перенесено {count} файлов ({size}) в Trash. Проверьте сайт, затем Empty или Restore.',
      trashMoveFailed: 'Не удалось перенести в Trash',
      trashRestoreSuccess: 'Восстановлено {count} файлов (пропущено {skipped})',
      trashRestoreFailed: 'Не удалось восстановить из Trash',
      trashSelectRestore: 'Выберите файлы для восстановления',
      trashEmptySuccess: 'Безвозвратно удалено {count} файлов ({size})',
      trashEmptyFailed: 'Не удалось очистить Trash',
      trashEmptyConfirmTitle: 'Очистить Trash безвозвратно?',
      trashEmptyConfirmMessage: 'Будет удалено {count} файлов ({size}). Отменить нельзя.',
      biddingTrashTitle: 'Корзина смет',
      biddingTrashHint: 'Мягко удалённые сметы. Restore вернёт в список. Purge удалит навсегда.',
      biddingTrashSuperAdminOnly: 'Восстанавливать и окончательно удалять сметы из корзины может только Super Admin.',
      biddingTrashCount: 'В корзине: {count}',
      biddingTrashEmpty: 'Удалённых смет нет',
      biddingTrashColName: 'Название',
      biddingTrashColProject: 'Проект',
      biddingTrashColShots: 'Шоты',
      biddingTrashColDeleted: 'Удалено',
      biddingTrashColActions: 'Действия',
      biddingTrashRestore: 'Восстановить',
      biddingTrashRestoreSelected: 'Восстановить выбранные',
      biddingTrashPurge: 'Удалить навсегда',
      biddingTrashLoadFailed: 'Не удалось загрузить корзину смет',
      biddingTrashRestoreSuccess: 'Смета восстановлена',
      biddingTrashRestoreFailed: 'Не удалось восстановить смету',
      biddingTrashRestoreBatch: 'Восстановлено {ok}, ошибок {failed}',
      biddingTrashPurgeSuccess: 'Смета удалена навсегда',
      biddingTrashPurgeFailed: 'Не удалось удалить смету навсегда',
      biddingTrashPurgeConfirmTitle: 'Удалить смету навсегда?',
      biddingTrashPurgeConfirmMessage: 'Это нельзя отменить. Шоты и назначения будут удалены безвозвратно.',
    },
    activityLogs: {
      title: 'Логи активности',
      description: 'Просмотр аудита и логов активности системы',
    },
    vfx: {
      title: 'LightBox API',
      description: 'API endpoints для интеграции с LightBox',
      accessDenied: 'Доступ запрещен',
      accessDeniedDescription: 'Эта функция доступна только для Super Admin',
      integration: 'Интеграция с LightBox',
      integrationDescription: 'Интеграция SpellBook ↔ LightBox активна. Доступна синхронизация комментариев, аннотаций и статусов шотов.',
      syncActive: 'Синхронизация активна',
      pushDescription: 'Отправка комментариев и аннотаций из SpellBook в LightBox',
      pullDescription: 'Получение статусов шотов и прогресса из LightBox',
      documentation: 'Документация API доступна в файле LIGHTBOX_INTEGRATION.md',
    },
    themes: {
      title: 'Редактор тем (beta)',
      description: 'Настройка цветовой схемы приложения',
    },
    studio: {
      title: 'Конфигурация студии',
      studioName: 'Название студии для интеграции LightBox',
      studioNameDescription: 'Это название будет использоваться LightBox для архитектуры с несколькими студиями. LightBox будет использовать этот идентификатор при подключении и импорте данных.',
      studioNamePlaceholder: 'Введите название студии (например, Main Studio, Studio A)',
      save: 'Сохранить',
      saved: 'Сохранено!',
      error: 'Ошибка сохранения',
      note: 'Примечание',
      noteText: 'LightBox будет читать эту настройку через API endpoint',
      toIdentify: 'чтобы идентифицировать вашу студию и импортировать профили/проекты.',
    },
    ui: {
      title: 'Настройки интерфейса',
      description: 'Тема и масштабирование',
      theme: {
        title: 'Тема оформления',
        current: 'Текущая тема',
        dark: 'Темная',
        light: 'Светлая',
        toggle: 'Переключить',
      },
      scaling: {
        title: 'Масштабирование',
        current: 'Текущий масштаб',
        description: 'Изменение размера элементов интерфейса',
      },
    },
    about: {
      title: 'О системе',
      description: 'Информация о приложении',
      version: 'Версия',
      buildInfo: {
        title: 'Информация о сборке',
        version: 'Версия',
        buildDate: 'Дата сборки',
        buildTime: 'Время сборки',
        environment: 'Окружение',
      },
      features: {
        title: 'Основные возможности',
        artists: 'Управление художниками',
        projects: 'Планирование проектов',
        backup: 'Система бэкапов',
        roles: 'Ролевая модель доступа',
      },
      tech: {
        title: 'Технологии',
      },
    },
    changelog: {
      title: 'Changelog',
      description: 'История изменений и обновлений',
      version: 'Версия',
      current: 'Текущая',
      previousVersions: 'Предыдущие версии',
      fullChangelog: 'Полный список изменений',
      magicbox: {
        title: 'Интеграция с LightBox',
        syncComments: 'Синхронизация комментариев и аннотаций SpellBook → LightBox',
        pullStatuses: 'Получение статусов шотов и прогресса LightBox → SpellBook',
        shotMapping: 'Автоматический и ручной маппинг шотов',
        syncHistory: 'История синхронизаций',
      },
      finance: {
        title: 'Финансовая система',
        transactions: 'Управление транзакциями (приход, расход, обязательства)',
        progressBars: 'Прогресс-бары зачислений и выплат',
        liabilities: 'Управление обязательствами (оплата, возврат, удаление)',
        grouping: 'Группировка транзакций и обязательств',
        artistNames: 'Автоматическое добавление имён исполнителей',
      },
      bidding: {
        title: 'Улучшения смет',
        conflicts: 'Определение конфликтов при массовом утверждении',
        paidIndicators: 'Визуальные индикаторы оплаченных задач',
        duplication: 'Дублирование комментариев и аннотаций',
        contextMenu: 'Контекстное меню для всех статусов',
        autoFees: 'Автоматическое создание обязательств для гонораров',
      },
      sceneDetection: {
        title: 'Детекция сцен',
        frameAccuracy: 'Точность до кадра (улучшено с 2-3 кадров)',
        extraction: 'Более точное извлечение кадров',
        boundaries: 'Улучшенная обработка границ сцен',
      },
      uiux: {
        title: 'UI/UX улучшения',
        collapsible: 'Сворачиваемые секции в финансах',
        projectMemory: 'Запоминание выбранного проекта',
        grouping: 'Группировка транзакций',
        errorMessages: 'Улучшенные сообщения об ошибках',
        bugfixes: 'Исправление множества багов',
      },
      v120: {
        description: 'Роль клиента + Email-уведомления',
      },
      v110: {
        description: 'Сметы и автоматизация VFX-редактирования',
      },
      v105: {
        description: 'Улучшения системы смет',
      },
    },
  },

  // Content View Toggle
  contentView: {
    users: 'Пользователи',
    artists: 'Профили',
    projects: 'Проекты',
    teams: 'Команды',
    rates: 'Ставки',
    bidding: 'Сметы',
    finance: 'Финансы',
  },

  teams: {
    dragHint: 'Shift+клик для выделения нескольких, перетащите на проект',
    dropToAssign: 'Перетащите профили сюда для назначения',
    noProjects: 'Нет проектов по фильтру',
    noProfiles: 'Нет профилей',
    assignedCount: '{{count}} назначено',
    draggingCount: 'Выбрано профилей: {{count}}',
  },

  // Project List View
  projectsList: {
    noProjects: 'Нет проектов',
    createFirst: 'Создайте первый проект',
    progress: 'Прогресс',
    linkedToMagicBox: 'Связан с LightBox',
  },

  // Project Status
  projectStatus: {
    planning: 'Планирование',
    active: 'Активный',
    inProgress: 'В работе',
    onHold: 'Приостановлен',
    completed: 'Завершён',
    cancelled: 'Отменён',
    magicbox: 'LightBox',
  },

  // Priority
  priority: {
    urgent: 'Срочный',
    low: 'Низкий',
    medium: 'Средний',
    high: 'Высокий',
    critical: 'Критический', // Deprecated, use urgent
  },

  // Project Types
  projectTypes: {
    featureFilm: 'Полнометражный фильм',
    tvSeries: 'Сериал',
    commercial: 'Реклама',
    musicVideo: 'Музыкальный клип',
    gameCinematic: 'Игровой ролик',
    vrAr: 'VR/AR',
    other: 'Прочее',
  },

  common: {
    locale: 'ru-RU',
    info: 'Информация',
    loading: 'Загрузка...',
    creating: 'Создание...',
    updating: 'Обновление...',
    saving: 'Сохранение...',
    processing: 'Обработка...',
    edit: 'Редактировать',
    delete: 'Удалить',
    deleting: 'Удаление...',
    save: 'Сохранить',
    cancel: 'Отмена',
    reset: 'Сбросить',
    previous: 'Назад',
    all: 'Все',
    next: 'Вперёд',
    add: 'Добавить',
    create: 'Создать',
    of: 'из',
    select: 'Выберите',
    notAssigned: 'Не назначен',
    fromProject: 'из проекта',
    notSet: 'Не указан',
    remove: 'Удалить',
    project: 'Проект',
    currency: 'Валюта',
    budget: 'Бюджет',
    created: 'Создано',
    itemsSelected: 'Выбрано элементов: {{count}}',
    deleteWarning: 'Это действие нельзя отменить. Все связанные данные будут безвозвратно удалены.',
    close: 'Закрыть',
    actions: 'Действия',
    connecting: 'Подключение...',
    syncing: 'Синхронизация...',
    date: 'Дата',
    status: 'Статус',
    optional: 'необязательно',
    confirmDelete: 'Подтвердите удаление',
    send: 'Отправить',
    back: 'Назад',
    uses: 'использований',
  },

  // Публичная анкета
  invite: {
    buttonText: 'Анкета',
    createInvite: 'Создать публичную ссылку на анкету',
    modalTitle: 'Публичная анкета',
    linkCreated: 'Ссылка успешно создана!',
    validFor24Hours: 'Ссылка действительна 24 часа',
    inviteLink: 'Ссылка на анкету',
    copyLink: 'Скопировать ссылку',
    copy: 'Скопировать',
    copied: 'Скопировано!',
    expiresAt: 'Истекает:',
    close: 'Закрыть',
    instructions: 'Как использовать:',
    instruction1: 'Скопируйте и отправьте эту ссылку кандидату',
    instruction2: 'Он сможет заполнить анкету без регистрации',
    instruction3: 'Вы увидите его профиль после отправки',
    tryAgain: 'Попробовать снова',
    applicationTitle: 'Анкета художника',
    applicationSubtitle: 'Заполните форму, чтобы попасть в нашу базу художников',
    // Поля формы
    profilePicture: 'Фотография профиля (необязательно)',
    fullName: 'Полное имя',
    email: 'Email',
    specialization: 'Специализация',
    selectSpecialization: 'Выберите специализацию',
    software: 'Программы и инструменты',
    selectAtLeastOne: 'Выберите хотя бы один',
    telegram: 'Telegram (необязательно)',
    phone: 'Телефон (необязательно)',
    location: 'Местоположение (необязательно)',
    portfolioUrl: 'Ссылка на портфолио (необязательно)',
    aboutYou: 'О себе (необязательно)',
    aboutPlaceholder: 'Расскажите о своем опыте, навыках и чего вы ищете...',
    chooseFile: 'Выбрать файл',
    noFileChosen: 'Файл не выбран',
    submitApplication: 'Отправить анкету',
    submitting: 'Отправка...',
    // Сообщения
    invalidToken: 'Недействительная ссылка',
    tokenMessage: 'Запросите новую ссылку у рекрутера.',
    success: 'Анкета отправлена!',
    successMessage: 'Спасибо за вашу анкету. Мы рассмотрим ваш профиль и свяжемся с вами в ближайшее время.',
    closeWindow: 'Вы можете закрыть эту страницу.',
    captchaRequired: 'Пожалуйста, пройдите проверку безопасности',
  },

  // Логи активности
  activityLogs: {
    title: 'Логи активности',
    subtitle: 'Аудит всех действий в системе',
    totalLogs: 'Всего логов',
    last24Hours: 'За 24 часа',
    topAction: 'Популярное действие',
    topUser: 'Самый активный',
    allActions: 'Все действия',
    allEntities: 'Все сущности',
    startDate: 'Начальная дата',
    endDate: 'Конечная дата',
    exportTxt: 'Экспорт в TXT',
    deleteOld: 'Удалить логи старше 30 дней',
    deleteAll: 'Удалить все логи',
    confirmDeleteOld: 'Вы уверены, что хотите удалить все логи старше 30 дней? Это действие нельзя отменить.',
    confirmDeleteAll: 'Вы уверены, что хотите удалить ВСЕ логи? Это действие нельзя отменить и удалит весь аудит.',
    deleteSuccess: 'Логи успешно удалены',
    deleteError: 'Ошибка удаления логов',
    noLogs: 'Логи не найдены',
    timestamp: 'Время',
    user: 'Пользователь',
    action: 'Действие',
    entity: 'Сущность',
    details: 'Детали',
    ip: 'IP адрес',
    showing: 'Показано {{start}} - {{end}} из {{total}} логов',
  },

  // Context Menu
  contextMenu: {
    edit: 'Редактировать',
    delete: 'Удалить',
    rename: 'Переименовать',
    duplicate: 'Дублировать',
    enterNewName: 'Введите новое название:',
    exportToExcel: 'Экспорт в Excel',
    assignToProject: 'Назначить на проект',
    inviteToProject: 'Пригласить на проект',
    createBiddingFromVideo: 'VFX монтаж в смету',
    createBiddingManual: 'Создать смету',
    createBidding: 'Создать смету',
    createArtist: 'Создать профиль художника',
    createProject: 'Создать новый проект',
    addUsersToProject: 'Добавить пользователей на проект',
    openInMagicBox: 'Открыть в LightBox',
    syncFromMagicBox: 'Синхронизировать из LightBox',
    magicboxNotConfigured: 'LightBox не настроен',
    projectNotInMagicBox: 'Проект "{{name}}" не подключён к LightBox',
    magicboxError: 'Ошибка при открытии в LightBox',
    createExpenseSheet: 'Создать расходную смету',
    exportRevenue: 'Доходная смета',
    exportExpense: 'Расходная смета',
    exportAll: 'Всё (Архив)',
    setStatus: 'Установить статус',
  },
  
  // Project Invitation
  projectInvitation: {
    title: 'Пригласить художников на проект',
    selectedArtists: 'Выбранные художники',
    selectProject: 'Выберите проект',
    chooseProject: 'Выберите проект...',
    projectDetails: 'Детали проекта',
    projectName: 'Проект',
    projectNameHidden: 'Название проекта будет скрыто (NDA)',
    dates: 'Даты',
    producer: 'Продюсер',
    supervisor: 'Супервайзер',
    description: 'Описание',
    hideProjectName: 'Скрыть название проекта',
    hideProjectNameHint: 'Название проекта не будет отображаться в приглашении (требуется NDA)',
    invitationMethod: 'Способ приглашения',
    available: 'доступно',
    sendInvitation: 'Отправить приглашение',
    someArtistsNoEmail: '{{count}} художник(ов) не имеют email и не получат приглашение',
    someArtistsNoTelegram: '{{count}} художник(ов) не имеют Telegram и не получат приглашение',
    invitationSent: 'Приглашение успешно отправлено!',
    invitationFailed: 'Не удалось отправить приглашение',
  },

  // Project Assignment
  projectAssignment: {
    assignTo: 'Назначить на проект',
    profile: 'профиль',
    profiles: 'профилей',
    searchProject: 'Поиск проекта...',
    noProjects: 'Проекты не найдены',
    assign: 'Назначить',
  },

  // Add Users to Project
  addUsersToProject: {
    title: 'Добавить пользователей на проект',
    searchPlaceholder: 'Поиск по имени, email или специализации...',
    selectAll: 'Выбрать все',
    selected: 'выбрано',
    noUsers: 'Нет доступных пользователей',
    alreadyAssigned: 'пользователей уже назначено',
    selectUsers: 'Пожалуйста, выберите хотя бы одного пользователя',
    add: 'Добавить',
    error: 'Не удалось добавить пользователей на проект',
  },

  // Bidding System
  bidding: {
    noBiddingSheets: 'Нет таблиц осмечивания',
    createFirstBidding: 'Создайте первую таблицу для осмечивания проекта',
    noBidding: 'Нет таблиц осмечивания',
    createFirst: 'Создайте первую таблицу для осмечивания проекта',
    revenueTable: 'Приходная',
    expenseTable: 'Расходная',
    sceneDetection: 'Анализ сцен',
    videoUploaded: 'Видео загружено',
    totalBudget: 'Итоговая сумма',
    createdBy: 'Создал',
    name: 'Название',
    namePlaceholder: 'Введите название осмечивания',
    nameRequired: 'Название обязательно',
    project: 'Проект',
    projectRequired: 'Выберите проект',
    video: 'Видео',
    videoRequired: 'Загрузите видео',
    createBiddingFromVideo: 'VFX монтаж в смету',
    createBiddingManual: 'Создать смету',
    createBidding: 'Создать осмечивание',
    editBidding: 'Редактировать',
    uploadVideo: 'Загрузить видео',
    detectScenes: 'Анализировать сцены',
    biddingName: 'Название осмечивания',
    selectProject: 'Выберите проект',
    dragDropVideo: 'Перетащите видео сюда или нажмите для выбора',
    supportedFormats: 'Поддерживаемые форматы',
    selectVideo: 'Выбрать видео',
    selectFile: 'Выбрать файл',
    invalidFileType: 'Неподдерживаемый формат файла',
    uploading: 'Загрузка видео...',
    detectingScenes: 'Анализ сцен...',
    scenesDetected: 'сцен найдено',
    recognizingNames: 'чтение имён',
    detectionProgress: 'Прогресс детекции',
    detectionPhase2: 'Фаза 2: добор пропусков…',
    detectionShots: 'шотов',
    detectionPlayhead: 'таймлайн',
    detectionFailed: 'Детекция сцен не удалась',
    shotFilter: 'Список шотов',
    shotFilterPlaceholder: 'Вставьте коды или номера: 123a_0010, 0010, ABC0020…',
    shotFilterHint: 'Необязательно. В смету попадут только совпавшие шоты (Enter/запятая).',
    shotFilterCount: 'в фильтре',
    shotFilterNoMatches: 'Ни один шот из монтажа не совпал со списком',
    insertMissingShots: 'Добавить ненайденные из списка',
    insertMissingShotsHint: 'После детекции оставшиеся позиции списка добавятся пустыми шотами (по сортировке). Пропуски между соседями заполняются из cuts монтажа; если между matched-соседями нет cut — только placeholder (gapsWithoutCuts в статусе).',
    sceneDetectionInfo: 'После загрузки видео начнется автоматический анализ сцен',
    manualModeInfo: 'Создайте таблицу с указанным количеством шотов для ручного заполнения',
    shotCount: 'Количество шотов',
    shotCountPlaceholder: 'Введите количество шотов',
    shotCountRequired: 'Укажите количество шотов',
    shotCountHint: 'Укажите предполагаемое количество шотов (1-1000)',
    createError: 'Ошибка при создании осмечивания',
    shotTable: 'Таблица шотов',
    shotsTable: 'Таблица шотов',
    shots: 'Шоты',
    addShot: 'Добавить шот',
    thumbnail: 'Миниатюра',
    shotNumber: '№ шота',
    frameIn: 'Frame In',
    frameOut: 'Frame Out',
    timecodeIn: 'Таймкод In',
    timecodeOut: 'Таймкод Out',
    duration: 'Длительность',
    comment: 'Комментарий',
    commentPlaceholder: 'Введите комментарий',
    teamLeadShot: 'Лидер шота',
    teamLead: 'Тим-лид',
    hours: 'Часы',
    rate: 'Ставка',
    sum: 'Сумма',
    total: 'Итого',
    selectArtist: 'Выберите художника',
    addSpecialization: 'Добавить специализацию',
    newSpecialization: 'Название специализации',
    noShots: 'Нет шотов',
    uploadVideoToDetect: 'Загрузите видео для автоматического создания шотов',
    bidSuffix: 'смета v01',
    selectSpecializations: 'Выберите специализации для колонок',
    specializationsHint: 'Выбранные специализации будут добавлены как колонки в таблицу',
    specializationsRequiredTitle: 'Специализации не выбраны',
    specializationsRequiredMessage: 'Поле колонок пайплайна отмечено *. Без выбора в таблице бида не будет колонок специализаций. Выберите хотя бы одну или продолжите без колонок.',
    continueWithoutSpecializations: 'Продолжить без колонок',
    goSelectSpecializations: 'Выбрать',
    doubleClickToEdit: 'Двойной клик для редактирования',
    duplicateNameError: 'Смета с таким названием уже существует',
    
    // Аннотации и имена шотов
    annotate: 'Аннотировать',
    shotName: 'Имя шота',
    shotNamePlaceholder: 'напр., SHOT_0010',
    autofill: 'Автозаполнение имён шотов',
    autofillDetected: 'Обнаружен паттерн',
    autofillConfirm: 'Применить автозаполнение к {count} шотам?',
    autofillApply: 'Применить автозаполнение',
    autofillCancel: 'Отмена',
    autofillPattern: 'Паттерн: {pattern}',
    autofillStep: 'Шаг: +{step}',
    autofillButton: 'Автозаполнение',
    autofillForce: 'Принудительное автозаполнение',
    autofillNoPattern: 'Паттерн не обнаружен. Убедитесь, что имена шотов следуют единому шаблону (напр., SHOT_0010, SHOT_0020)',
    autofillNeedTwoShots: 'Необходимо минимум 2 заполненных имени шота для определения паттерна',
    autofillCloseAnnotation: 'Пожалуйста, сначала закройте модальное окно аннотации',
    autofillAllFilled: 'Все шоты уже заполнены',
    
    // Settings Modal
    settings: 'Настройки сметы',
    financialSettings: 'Финансовые настройки',
    documentsPayment: 'Документы и оплата',
    invoiceNumber: '№ счета',
    contractNumber: '№ договора',
    paymentDeadline: 'Срок оплаты',
    paymentDate: 'Дата оплаты',
    paymentStatus: 'Статус оплаты',
    statusLabel: 'Статус сметы',
    projectCurrency: 'Валюта проекта',
    projectCurrencyHint: 'Наследуется от проекта. Измените в настройках проекта — обновится для всех смет.',
    
    // Approval
    sendForApproval: 'На согласование',
    approve: 'Утвердить',
    reject: 'Отклонить',
    approved: 'Утверждено',
    reopen: 'Открыть заново',
    
    // Reapprove modal
    reapproveTitle: 'Обновить финансы?',
    reapproveMessage: 'Вы изменили гонорары управления. Чтобы изменения отразились в финансах, необходимо переодобрить смету. Это обновит существующие обязательства.',
    saveOnly: 'Только сохранить',
    saveAndReapprove: 'Сохранить и обновить',

    status: {
      draft: 'Черновик',
      processing: 'Обработка',
      completed: 'Завершено',
      failed: 'Ошибка',
      pending: 'Ожидает оплаты',
      partial: 'Частично',
      paid: 'Оплачено',
      overdue: 'Просрочено',
      sent: 'На согласовании',
      approved: 'Утверждено',
      rejected: 'Отклонено',
    },
    
    statuses: {
      draft: 'Черновик',
      processing: 'Обработка',
      ready: 'Готова',
      sent: 'На согласовании',
      approved: 'Утверждена',
      rejected: 'Отклонена',
      hidden: 'Скрыта',
    },
    
    actions: {
      hide: 'Скрыть смету',
      unhide: 'Показать смету',
      hiddenInfo: 'Эта смета скрыта от клиента',
    },
    
    detectionStatuses: {
      pending: 'Ожидание',
      processing: 'Обработка',
      completed: 'Завершено',
      failed: 'Ошибка',
    },
    
    artistRates: {
      title: 'Ставки и гонорары',
      button: 'Ставки и гонорары',
      titleExpense: 'Ставки художников',
      titleRevenue: 'Ставки ролей',
      buttonExpense: 'Ставки художников',
      buttonRevenue: 'Ставки ролей',
      description: 'Установите почасовые ставки для художников проекта по специализациям',
      filterBySpec: 'Фильтр по специализации',
      noArtists: 'Нет художников в проекте',
      customParticipants: 'Неанкетированные участники',
      addParticipantPlaceholder: 'Введите имя...',
      artistsTitle: 'Художники',
      deleteParticipantConfirm: 'Вы уверены, что хотите удалить этого участника?',
      deleteSpecTitle: 'Удалить специализацию',
      deleteSpecConfirm: 'Удалить специализацию',
      deleteSpecWarning: 'Это удалит все назначения для этой специализации.',
      projectSpecializations: 'Специализации проекта',
      globalRate: 'Глобальная ставка',
      customRate: 'Кастомная ставка',
      noSpecializations: 'Нет специализаций. Добавьте первую выше.',
      globalRateLabel: 'Глобальная: {{rate}}',
    },
    
    subtotal: 'Промежуточный итог',
    producerFee: 'Гонорар продюсера',
    fixedAmount: 'Фикс. сумма',
    globalValue: 'Глобальное',
    customValue: 'Кастомное',
    globalDefault: 'Глобальное значение',
    fromRevenue: 'с прихода',
    coordinatorFee: 'Гонорар координатора',
    supervisorFee: 'Гонорар супервайзера',
    managementFees: 'Гонорары управления',
    grandTotal: 'ИТОГО',
    noArtistsForSpec: 'Нет художников',
    playShot: 'Воспроизвести шот',
    replaceThumbnail: 'Заменить миниатюру',
    deleteShot: 'Удалить шот',
    renameSpecialization: 'Переименовать специализацию',
    fillColumnWithLevel: 'Заполнить колонку уровнем',
    confirmFillColumn: 'Назначить {{level}} во все незаполненные ячейки колонки «{{spec}}»? ({{count}} шт.)',
    confirmClearColumn: 'Сбросить уровень во всех назначенных ячейках колонки «{{spec}}»? ({{count}} шт.)',
    renameSpecializationConflict: 'Специализация «{{name}}» уже есть на листе',
    renameSpecializationFailed: 'Не удалось переименовать специализацию',
    noRenameTargets: 'Нет доступных пайплайнов',
    deleteColumn: 'Удалить колонку',
    confirmDeleteColumn: 'Удалить колонку «{{spec}}» и все назначения в ней? ({{count}} шт.)',
    deleteColumnFailed: 'Не удалось удалить колонку',
    cannotDeleteLastColumn: 'Нельзя удалить последнюю колонку на листе',
    confirmDeleteShot: 'Вы уверены, что хотите удалить шот',
    confirmDeleteShots: 'Удалить выбранные шоты',
    confirmDeleteMultipleShots: 'Вы уверены, что хотите удалить {{count}} шотов?',
    shotWillBeDeleted: 'Этот шот и все его назначения будут удалены. Номера шотов будут автоматически перенумерованы.',
    deleteSelected: 'Удалить выбранные',
    deleteShots: 'Удалить шоты',
    confirmDelete: 'Подтвердить',
    showing: 'Показано',
    of: 'из',
    perPage: 'на стр.',
    aggregationBySpec: 'Специализация',
    aggregationByLevel: 'Уровень',
    totalsRow: 'Итого',
    columns: {
      hide: 'Скрыть колонку',
      unhideAll: 'Показать все колонки',
    },
    levelOther: 'Не указан',
    levelJunior: 'Junior',
    levelMid: 'Mid',
    levelSenior: 'Senior',
    levelLead: 'Lead',
    participantPayments: 'Выплаты участникам',
    summary: 'Итоги',
    totalShots: 'Всего шотов',
    totalParticipants: 'Всего участников',
    noAssignments: 'Нет назначений',
    projectFees: 'Гонорары проекта',
    shotUnit: 'шот',
    shotsUnit: 'шотов',
    producerName: 'Имя продюсера',
    supervisorName: 'Имя супервайзера',
    finderName: 'Привлечение',
    finderFee: 'Гонорар за привлечение',
    selectFinder: '— Выберите —',
    coordinatorName: 'Координатор',
    enterName: 'Введите имя',
    exportExcel: 'Экспорт Excel',
    exportExcelTitle: 'Экспорт Excel',
    exportExcelIntro: 'Выберите вариант файла:',
    exportExcelForClient: 'Для клиента',
    exportExcelForClientHint: 'Один лист «Смета» — без ставок и внутренних вкладок',
    exportExcelForInternal: 'Для внутреннего использования',
    exportExcelForInternalHint: 'Полный файл: шоты, ставки, сводка (доходная + расходная)',
    exportExcelExporting: 'Экспорт…',
    exportError: 'Не удалось экспортировать Excel',
    exportVideo: 'Экспорт сметы в видео',
    exportVideoShort: 'Видео',
    exportVideoTitle: 'Экспорт сметы в видео',
    exportVideoIntro: 'Экспорт {{clips}} из {{total}} шотов этой сметы.',
    exportVideoMissingClips: 'без клипов — попробуем сгенерировать',
    exportVideoModePerShot: 'Файл на шот',
    exportVideoModeSingle: 'Один файл',
    exportVideoFolderHint: 'Каждый шот — файл [shot]_ref_[version].mp4 (напр. 281_0010_ref_3.mp4). Выберите папку.',
    exportVideoZipHint: 'Выбор папки недоступен в этом браузере — каждый шот скачается отдельно в «Загрузки» (разрешите множественные скачивания, если браузер спросит).',
    exportVideoFilename: 'Имя файла',
    exportVideoFilenameHint: 'По умолчанию: название проекта + название сметы',
    exportVideoPreparing: 'Подготовка клипов…',
    exportVideoConcat: 'Склейка видео…',
    exportVideoChooseFolder: 'Выбрать папку и экспорт',
    exportVideoDownloadFiles: 'Скачать файлы',
    exportVideoDownload: 'Скачать видео',
    exportVideoSuccessSingle: 'Видео скачано',
    exportVideoSuccessPerShot: 'Сохранено файлов в папку: {{count}}',
    exportVideoSuccessSequential: 'Скачано файлов: {{count}} — проверьте папку «Загрузки»',
    exportVideoSkipped: 'Пропущено',
    exportVideoNoClips: 'Нет видеоклипов шотов для экспорта',
    exportVideoFailed: 'Не удалось экспортировать видео',
    exportVideoCancelled: 'Экспорт отменён',
    exportVideoAuthError: 'Нет авторизации',
    ai: {
      title: 'AI Bid Allocator',
      button: 'AI Bid',
      analyze: 'Анализ',
      allocate: 'Распределить',
      undo: 'Отменить',
      analyzing: 'Анализ шотов…',
      analyzed: 'Проанализировано',
      allocating: 'Распределение бюджета…',
      allocated: 'Готово',
      undone: 'Откат выполнен',
      working: 'В процессе…',
      budgetRequired: 'Укажите бюджет',
      useProjectBudget: 'Бюджет проекта',
      targetBudget: 'Целевой бюджет',
      feeArtistsNet: 'Бюджет = артисты',
      feeGross: 'Gross → минус fees/VAT',
      analyses: 'Анализы',
      chatHint: 'Пример: «урежь шот 5 в 2 раза», «урежь в 2 раза все подобные 5»',
      chatPlaceholder: 'Команда коррекции…',
      column: 'AI',
      description: 'Описание',
      descriptionPlaceholder: 'VFX notes…',
      analyzeFirst: 'Сначала запустите Анализ — шоты ещё не проанализированы.',
      contextMode: 'Режим',
      contextColumns: 'Колонки',
      specResolutionTitle: 'Обнаруженные типы работ',
      specResolutionHint: 'AI определил дисциплины, которых нет в таблице. Выберите действие для каждой.',
      specResolutionCreate: 'Создать колонку',
      specResolutionRedistribute: 'Перераспределить',
      specResolutionIgnore: 'Игнорировать',
      specResolutionShots: 'Шотов',
      specResolutionWeights: 'Маппинг весов (%)',
      specResolutionEven: 'Равномерно',
      specResolutionSum: 'Сумма',
      specResolutionContinue: 'Продолжить распределение',
      specResolutionWeightError: 'Сумма весов должна быть 100%',
    },
    exportParticipant: 'Экспорт участника',
    insertRowAbove: 'Вставить строку выше',
    insertRowBelow: 'Вставить строку ниже',
    copyRowHours: 'Скопировать ряд (часы)',
    copyRowSum: 'Скопировать ряд (суммы)',
    pasteRowHours: 'Вставить ряд (часы)',
    pasteRowSum: 'Вставить ряд (суммы)',
    totalHours: 'Всего часов',
    totalPayment: 'Общая выплата',
    payment: 'Выплата',
    specialization: 'Специализация',
    profitPool: 'Прибыль',
    totalNet: 'Сумма (Net)',
    vat: 'НДС',
    totalGross: 'Итого с НДС',
    projectTaxRate: 'Налоговая ставка проекта',
    projectTaxRateHint: 'Налог рассчитывается автоматически на все поступления',
  },

  // Transactions
  transactions: {
    title: 'Транзакции',
    selectProject: 'Выбрать проект',
    selectProjectFirst: 'Выберите проект для просмотра транзакций',
    allBiddingSheets: 'Все сметы',
    balance: 'Баланс',
    totalIncome: 'Приход',
    totalExpense: 'Расход',
    addTransaction: 'Добавить транзакцию',
    editTransaction: 'Редактировать транзакцию',
    date: 'Дата',
    category: 'Категория',
    description: 'Описание',
    amount: 'Сумма',
    type: 'Тип',
    in: 'Приход',
    out: 'Расход',
    noTransactions: 'Нет транзакций',
    noProjects: 'Нет доступных проектов',
    confirmDelete: 'Вы уверены, что хотите удалить эту транзакцию?',
    descriptionPlaceholder: 'Например: Приход от клиента',
    filter: {
      all: 'Все',
      allCategories: 'Все категории',
    },
    categoryLabels: {
      CLIENT_DEPOSIT: 'Приход',
      ARTIST_PAYOUT: 'Зарплата',
      SOFTWARE_HARDWARE: 'Расходы',
      OTHER: 'Прочее',
    },
    // Financial metrics
    totalGrossIncome: 'Общий приход',
    taxReserve: 'Налоговый резерв',
    pendingLiabilities: 'Ожидает выплат',
    paidLiabilities: 'Выплаченные',
    noPendingLiabilities: 'Нет ожидающих обязательств',
    noPaidLiabilities: 'Нет выплаченных обязательств',
    managementFees: 'Гонорары управления',
    producer: 'Продюсер',
    coordinator: 'Координатор',
    supervisor: 'Супервайзер',
    finder: 'Привлечение',
    producerFee: 'Продюсерский гонорар',
    coordinatorFee: 'Гонорар координатора',
    supervisorFee: 'Гонорар супервайзера',
    finderFee: 'Гонорар за привлечение',
    artistPayments: 'Выплаты исполнителям',
    paidToArtists: 'Выплачено исполнителям',
    feesTotal: 'Итого гонорары',
    totalPaid: 'ВСЕГО ВЫПЛАЧЕНО:',
    budgetProgress: 'Прогресс выплат',
    incomeProgress: 'Прогресс зачислений',
    paymentsProgress: 'Прогресс выплат',
    received: 'Получено',
    awaitingPayment: 'Ожидает оплаты',
    totalLiabilities: 'Всего обязательств',
    paid: 'Выплачено',
    pending: 'Ожидает выплаты',
    remaining: 'Остаток',
    totalBudget: 'Бюджет',
    netCashAvailable: 'Доступные средства',
    // Prepayment warnings
    prepaymentLevel: 'Предоплата',
    prepaymentRequired: 'Требуется предоплата',
    prepaymentRequiredText: 'Для начала производства требуется предоплата',
    prepaymentRequiredAmount: 'Требуется: {{amount}}',
    prepaymentPaidAmount: 'Внесено: {{amount}}',
    prepaymentRemainingAmount: 'Осталось: {{amount}}',
    prepaymentContactProducer: 'Пожалуйста, свяжитесь с продюсером для завершения предоплаты.',
    // Cash gap warning
    cashGapWarning: 'ПРЕДУПРЕЖДЕНИЕ О КАССОВОМ РАЗРЫВЕ',
    cashGapWarningText: 'Обязательства ({{liabilities}}) превышают доступные средства ({{available}}).',
    noProjectsAvailable: 'Проекты не загружены. Проверьте подключение к API.',
    // Liabilities
    liabilities: 'Обязательства',
    groupBy: 'Группировать',
    groupByShot: 'По шоту',
    groupByArtist: 'По артисту',
    groupByArtistSummary: 'Сводка по артистам',
    groupSimilar: 'Группировать',
    tasks: 'задач',
    paidOf: 'Оплачено:',
    of: 'из',
    showDetails: 'Показать детали',
    pendingTasks: 'Ожидает оплаты',
    paidTasks: 'Оплачено',
    totalPending: 'ВСЕГО ОЖИДАЕТ:',
    grandTotal: 'ИТОГО:',
    total: 'ИТОГО',
    pay: 'Оплатить',
    payLiability: 'Оплатить обязательство',
    payAmount: 'Сумма оплаты',
    totalAmount: 'Общая сумма',
    partialPaymentHint: 'Оставьте пустым для полной оплаты',
    invalidAmount: 'Неверная сумма',
    amountExceedsLiability: 'Сумма превышает обязательство',
    payError: 'Ошибка при оплате',
    // Pay all
    payAll: 'Выплатить всё',
    confirmPayAll: 'Выплатить все обязательства для',
    itemsCount: 'Позиций',
    payAllPartialSuccess: 'Оплачено',
    errors: 'ошибок',
    // Delete liability
    deleteLiability: 'Удалить обязательство',
    confirmDeleteLiability: 'Удалить обязательство?',
    deleteNotAllowed: 'Удаление обязательств доступно только администраторам и продюсерам',
    deleteError: 'Ошибка при удалении',
    deleteWarning: 'Это действие нельзя отменить. Обязательство будет удалено безвозвратно.',
    artist: 'Артист',
    // Delete transaction
    deleteTransaction: 'Удалить транзакцию',
    confirmDeleteTransaction: 'Вы уверены, что хотите удалить эту транзакцию?',
    deleteTransactionWarning: 'Это действие нельзя отменить. Транзакция будет удалена безвозвратно.',
    // Revert payment
    revertPayment: 'Отменить выплату',
    revertPaymentWarning: 'Выплата будет отменена и вернётся в список ожидающих обязательств.',
    confirmRevertPayment: 'Вернуть обязательство в ожидающие?',
    reverting: 'Отмена...',
    revert: 'Отменить выплату',
    revertError: 'Ошибка при отмене выплаты',
    // Coverage visualization
    coveragePreview: 'Покрытие обязательств',
    fullyCovered: 'Полностью покрыты',
    partiallyCovered: 'Частично покрыто',
    remainingAfterCoverage: 'Остаток после покрытия',
    noCoverage: 'Этот транш не покроет обязательства',
    // Export
    export: 'Экспорт',
    exportTooltip: 'Экспортировать транзакции в CSV',
    exportError: 'Ошибка экспорта',
  },
  
  // Bulk Approve Modal
  bulkApprove: {
    title: 'Отправить в финансы',
    selectedShots: 'Выбрано шотов',
    selectDepartments: 'Выберите департаменты для утверждения:',
    selectAll: 'Выбрать все',
    deselectAll: 'Снять все',
    noDepartmentsAvailable: 'Нет доступных департаментов для утверждения',
    allAlreadyApproved: 'Все назначения для выбранных шотов уже утверждены',
    fetchError: 'Не удалось загрузить список департаментов',
    approve: 'Утвердить',
    approving: 'Утверждение...',
    cancel: 'Отмена',
    selectAtLeastOne: 'Выберите хотя бы один департамент',
    approveError: 'Ошибка при утверждении расходов',
    // Conflict handling
    conflictsFound: 'Обнаружены конфликты',
    conflictsDescription: 'Некоторые позиции уже существуют в финансовых обязательствах. Выберите действие:',
    existingTasks: 'Уже существующие задачи',
    existingFees: 'Существующие гонорары',
    newTasks: 'Новые задачи для добавления',
    newFees: 'Новые гонорары для добавления',
    current: 'Текущая',
    new: 'Новая',
    skipExisting: 'Пропустить существующие позиции (добавить только новые)',
    updateFees: 'Обновить суммы существующих гонораров',
    updateExisting: 'Обновить суммы существующих позиций и гонораров',
    confirm: 'Подтвердить',
  },
  
  // Prepayment
  prepayment: {
    title: 'Предоплата',
    notSet: 'Не задано',
    percentOfBudget: '% от бюджета',
    fixedAmount: 'Фиксированная сумма',
    placeholderPercent: '0-100',
    placeholderAmount: 'Сумма',
    label: 'Предоплата',
    prepaymentLabel: 'Предоплата',
    threshold: 'Порог предоплаты',
    checkTransactions: 'Требуется предоплата',
    secured: 'Предоплата внесена',
  },
  
  // Finance
  finance: {
    payments: 'Выплаты',
    paid: 'Оплачено',
  },

  // Profit Distribution
  profitDistribution: {
    title: 'Распределение прибыли',
    available: 'Доступно',
    revenueTotal: 'Grand Total',
    taxReserve: 'Налог',
    expenses: 'Расходы',
    producerFee: 'Продюсер',
    coordinatorFee: 'Координатор',
    supervisorFee: 'Супервайзер',
    finderFee: 'Привлечение',
    distributed: 'Распределено',
    availableProfit: 'Прибыль',
    createDistribution: 'Создать распределение',
    distributions: 'Распределения',
    paid: 'Выплачено',
    approved: 'Утверждено',
    draft: 'Черновик',
    payAll: 'Выплатить всем',
    noProfitYet: 'Прибыль пока недоступна для распределения',
    profitHint: 'Прибыль появится после получения оплаты и выплаты всех обязательств',
    amount: 'Сумма',
    maxAvailable: 'Максимум',
    distributionPreset: 'Пресет распределения',
    equalManagers: 'Равные доли среди управляющих',
    equalArtists: 'Равные доли среди исполнителей',
    equalAll: 'Равные доли среди всех',
    customDistribution: 'Произвольное распределение',
    participants: 'Участники',
    manager: 'Управляющий',
    artist: 'Исполнитель',
    totalPercentage: 'Всего',
    mustBe100: 'должно быть 100%',
    noParticipants: 'Нет участников для выбранного пресета',
    create: 'Создать',
    participant: 'Участник',
    payout: 'Выплата',
    totalPayout: 'Итого к выплате',
    equalShares: 'Поровну',
    resetAll: 'Сбросить',
    deleteDistribution: 'Удалить распределение',
    confirmDelete: 'Удалить это распределение прибыли?',
    confirmDeleteDistributed: 'Удалить это распределение? Все связанные транзакции выплаты прибыли также будут удалены.',
    paidProfit: 'Прибыль',
    profit: 'Прибыль',
  },

  // LightBox Integration
  magicbox: {
    title: 'Синхронизация с LightBox',
    connect: 'Подключение',
    sync: 'Синхронизация',
    history: 'История',
    url: 'URL LightBox',
    email: 'Email',
    password: 'Пароль',
    testConnection: 'Проверить подключение',
    connectionSuccess: 'Успешно подключено к LightBox',
    connectionFailed: 'Не удалось подключиться к LightBox',
    connectDescription: 'Подключите этот проект к LightBox для синхронизации комментариев и отслеживания прогресса.',
    selectProject: 'Выберите проект LightBox',
    selectMagicboxProject: 'Выберите проект LightBox для связи:',
    saveConnection: 'Сохранить подключение',
    connectionSaved: 'Подключение к LightBox сохранено',
    saveFailed: 'Не удалось сохранить подключение',
    alreadyConnected: 'Уже подключено к LightBox',
    projectProgress: 'Прогресс проекта',
    shotsCompleted: 'шотов завершено',
    lastSync: 'Последняя синхронизация',
    pushToMagicBox: 'Отправить в LightBox',
    pushDescription: 'Отправить комментарии и аннотации из этой сметы в LightBox.',
    pullFromMagicBox: 'Получить из LightBox',
    pullDescription: 'Получить статусы шотов и прогресс из LightBox.',
    push: 'Отправить',
    pull: 'Получить',
    noBiddingSheet: 'Не выбрана смета',
    pushFailed: 'Не удалось отправить в LightBox',
    pullFailed: 'Не удалось получить из LightBox',
    syncResults: 'Результаты синхронизации',
    synced: 'Синхронизировано',
    errors: 'Ошибки',
    direction: 'Направление',
    items: 'Элементы',
    noHistory: 'История синхронизации пуста',
  },

  // Rates settings
  rates: {
    title: 'Настройки ставок',
    tabs: {
      virtualArtists: 'Виртуальные артисты',
      commissions: 'Комиссии',
      taxesCurrency: 'Налоги и валюты',
      specializations: 'Специализации',
    },
    info: {
      title: 'Информация:',
      description: 'Глобальные настройки применяются по умолчанию при создании новых проектов и смет. Их можно переопределить на уровне проекта.',
    },
    virtual: {
      title: 'Ставки виртуальных артистов',
      description: 'Базовые ставки для Junior / Mid / Senior / Lead артистов по специализациям',
      junior: 'Junior',
      mid: 'Mid',
      senior: 'Senior',
      lead: 'Lead',
      perHour: 'руб/час',
      saveSuccess: 'Ставки сохранены',
      saveError: 'Ошибка сохранения ставок',
    },
    commissions: {
      title: 'Комиссии по умолчанию',
      description: 'Значения по умолчанию для комиссий в новых сметах',
      producer: 'Продюсер',
      coordinator: 'Координатор',
      supervisor: 'Супервайзер',
      finder: 'Finder',
      percentage: 'Процент',
      fixed: 'Фикс',
      saveSuccess: 'Комиссии сохранены',
    },
    taxes: {
      title: 'Налоги и валюты',
      description: 'Финансовые параметры по умолчанию',
      defaultCurrency: 'Валюта по умолчанию',
      vatRate: 'Ставка НДС',
      profitTaxRate: 'Налог на прибыль',
      saveSuccess: 'Настройки сохранены',
    },
    specializations: {
      title: 'Специализации',
      description: 'Управление списком доступных специализаций',
      addNew: 'Добавить специализацию',
      placeholder: 'Название специализации',
      active: 'Активные',
      hidden: 'Скрытые',
      moveUp: 'Вверх',
      moveDown: 'Вниз',
      hide: 'Скрыть',
      show: 'Показать',
      delete: 'Удалить',
      saveSuccess: 'Специализации сохранены',
    },
    common: {
      save: 'Сохранить',
      cancel: 'Отмена',
      loading: 'Загрузка...',
      noPermission: 'Недостаточно прав для редактирования',
    },
  },

  // Review player / comments (LightBox-aligned)
  player: {
    comments: 'Комментарии',
    noComments: 'Пока нет комментариев к этой версии.',
    justNow: 'только что',
    minutesAgo: '{{count}} мин назад',
    hoursAgo: '{{count}} ч назад',
    daysAgo: '{{count}} дн назад',
    sortByTimecode: 'Таймкод',
    sortByDate: 'Дата',
    reply: 'Ответить',
    edit: 'Изменить',
    delete: 'Удалить',
    save: 'Сохранить',
    cancel: 'Отмена',
    drawingMode: 'Рисование',
    drawingModeOn: 'Рисование вкл.',
    undo: 'Отменить',
    clear: 'Очистить',
    attachFile: 'Прикрепить файл',
    record: 'Запись',
    stopRecording: 'Стоп',
    dictate: 'Диктовка',
    stopDictation: 'Стоп диктовки',
    send: 'Отправить',
    commentPlaceholder: 'Комментарий… (@ для упоминания)',
    replyPlaceholder: 'Ответ…',
    fileTooLarge: 'Файл слишком большой (макс. {{max}} МБ)',
    loopOnce: 'Один раз',
    loop: 'Цикл',
    bounce: 'Туда-обратно',
    mute: 'Без звука',
    unmute: 'Со звуком',
    fullscreen: 'Полный экран',
    exitFullscreen: 'Выйти из полного экрана',
    framePrev: 'Предыдущий кадр',
    frameNext: 'Следующий кадр',
    play: 'Играть',
    pause: 'Пауза',
  },
};
